
export class PluralOperands
{
    private fractionPattern = /\.(\d+)/;
    private exponentPattern = /[eE][+-]?(\d+)/;
    private value: number | string;

    constructor(value: number | string)
    {
        this.value = value;
    }

    // absolute value
    private _n?: number;
    public get n(): number
    {
        if (this._n == null)
        {
            const num = (typeof this.value == 'number' ? this.value : parseFloat(this.value));
            this._n = Math.abs(num);
        }
        return this._n;
    }

    // integer part
    private _i?: number;
    public get i(): number
    {
        if (this._i == null)
        {
            const num = (typeof this.value == 'number' ? this.value : parseFloat(this.value));
            this._i = Math.trunc(num);
        }
        return this._i;
    }

    // num of fraction digits (inc. trailing zeros)
    private _v?: number;
    public get v(): number
    {
        if (this._v == null)
        {
            this._v = this.fractionPart.length;
        }
        return this._v;
    }

    // num of fraction digits (exc. trailing zeros)
    private _w?: number;
    public get w(): number
    {
        if (this._w == null)
        {
            this._w = this.fractionPart.replace(/0+$/, '').length;
        }
        return this._w;
    }

    // fraction part (incl. trailing zeros)
    private _f?: number;
    public get f(): number
    {
        if (this._f == null)
        {
            this._f = +this.fractionPart;
        }
        return this._f;
    }

    // fraction part (exc. trailing zeros)
    private _t?: number;
    public get t(): number
    {
        if (this._t == null)
        {
            this._t = +this.fractionPart.replace(/0+$/, '');
        }
        return this._t;
    }

    // exponent
    private _c?: number;
    public get c(): number
    {
        if (this._c == null)
        {
            const str = (typeof this.value == 'number' ? String(this.value) : this.value);
            const match = str.match(this.exponentPattern);
            this._c = (match ? +match[1] : 0);
        }
        return this._c;
    }

    // alias for c
    public get e(): number
    {
        return this.c;
    }

    private _fractionPart?: string
    private get fractionPart(): string
    {
        if (this._fractionPart == null)
        {
            const str = (typeof this.value == 'number' ? String(this.value) : this.value);
            const match = str.match(this.fractionPattern);
            this._fractionPart = (match ? match[1] : '');
        }
        return this._fractionPart;
    }
}